import * as styles from './dividerline.module.scss';

import React from 'react';

const DividerLine = () => {
  return <div className={styles.divider} />;
};

export default DividerLine;
